<template>
	<section class="section">
		<div class="content">
			<h1 class="title">
				{{ recipe.name }}
				<a v-if="username" v-bind:href="'#/recipe/' + recipe._id + '/edit'">Edit</a>
			</h1>
			<h2 class="subtitle">
				Category: 
				<a v-bind:href="'#/categories/' + recipe.category">{{ recipe.category }}</a>
			</h2>
			<div v-if="recipe.tags" class="tags">
				<a v-for="tag in recipe.tags" :key="tag"
					class="tag is-warning"
					v-bind:href="'/#/tags/' + tag">{{ tag.toLowerCase() }}</a>
			</div>
			<p v-if="recipe.prep_time">Prep time: {{ recipe.prep_time.time }}</p>
			<p v-else>Prep time: {{ recipe.preptime }}</p>
			<p v-if="recipe.cook_time">Cook time: {{ recipe.cook_time.time }}</p>
			<p v-else>Cook time: {{ recipe.cooktime }}</p>
			<p>Servings: {{ recipe.servings }}</p>
			<h3 class="subtitle">Ingredients</h3>
			<ul v-for="(inggroup, index) in recipe.inggroups"
					v-bind:inggroup="inggroup"
					v-bind:key="index">
				<li v-for="(ingredient, index) in inggroup.ingredients"
						v-bind:ingredient="ingredient"
						v-bind:key="index">
					<span v-if="ingredient.name">{{ ingredient.amt }} {{ ingredient.unit }} {{ ingredient.name }}</span>
					<span v-else>{{ ingredient }}</span>
				</li>
			</ul>
			<ul>
				<li v-for="(ingredient, index) in recipe.ingredients"
						v-bind:ingredient="ingredient"
						v-bind:key="index">
					<span v-if="ingredient.name">{{ ingredient.amt }} {{ ingredient.unit }} {{ ingredient.name }}</span>
					<span v-else>{{ ingredient }}</span>
				</li>
			</ul>
			<h3 class="subtitle">Instructions</h3>
			<ol>
				<li v-for="(instruction, index) in recipe.instructions"
						v-bind:instruction="instruction"
						v-bind:key="index">{{ instruction }}</li>
			</ol>
			<p>{{ recipe.notes }}</p>
			<p>Source: {{recipe.source }}</p>
		</div>
	</section>
</template>

<script>
	import {db} from '@/variables.js'

	export default {
		props: ['id'],
		data: function () {
			return {
				username: "",
				recipe: {}
			}
		},
		created: function() {
			this.fetchData()
		},
		watch: {
			// call fetchData again if the route changes
			'$route': 'fetchData'
		},
		methods: {
			fetchData: function() {
				var vm = this

				db.getSession( function( err, response ) {
					if( !err ) {
						vm.username = response.userCtx.name
					}
				})

				db.get(vm.id).then(function(response){
					vm.recipe = response
					console.log(response)
				}).catch(function(err){
					alert(JSON.stringify(err))
				})
			}
		}
	}
</script>
